'use client';

import useAuthStore from '@/store/auth';
import React, { useState } from 'react';
import apiConfig from '@/config/url-api';
import { LogoutIcon } from '@/assets/icons';
import Dropdown from '@/components/ui/dropdown/Dropdown';

export default function UserDropdown() {
  const authStore = useAuthStore((state) => state);
  const { user } = authStore;

  const [isOpen, setIsOpen] = useState(false);

  function toggleDropdown(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  }

  function closeDropdown() {
    setIsOpen(false);
  }

  const nameParts = user?.customer_name.split(' ') || '';

  const initials = nameParts
    ?.slice(0, 2)
    //@ts-ignore
    ?.map((n) => n[0].toUpperCase())
    ?.join('');

  const logout = () => {
    localStorage.removeItem(apiConfig.auth.storageTokenKeyName);
    localStorage.removeItem(apiConfig.auth.storageUserKeyName);

    window.location.href = '/';
  };

  return (
    <div className="relative flex justify-center w-full">
      <button
        onClick={toggleDropdown}
        className="flex items-center justify-center h-10 w-10 rounded-full bg-brand-500 text-white font-semibold text-xs shadow-sm hover:opacity-90 transition-opacity cursor-pointer"
        aria-label="User profile menu"
      >
        {initials}
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={closeDropdown}
        className="absolute left-full bottom-0 ml-3 mb-2 flex w-52 flex-col rounded-xl border border-gray-200 bg-white p-2 shadow-xl dark:border-gray-800 dark:bg-gray-900 z-50"
      >
        <div className="px-2 py-1.5 border-b border-gray-100 dark:border-gray-800">
          <span className="block font-semibold text-gray-800 text-xs dark:text-gray-200 truncate">
            {user?.customer_name || 'User'}
          </span>
          <span className="mt-0.5 block text-[11px] text-gray-500 dark:text-gray-400 truncate">
            {user?.email || ''}
          </span>
        </div>

        <button
          onClick={logout}
          className="flex items-center w-full px-2.5 py-2 mt-1.5 font-medium text-red-600 dark:text-red-400 rounded-lg group text-xs hover:bg-red-50 dark:hover:bg-red-950/30 transition-colors cursor-pointer"
        >
          <LogoutIcon className="me-2 w-4 h-4" /> Logout
        </button>
      </Dropdown>
    </div>
  );
}
